import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { NavLink as Links } from "react-router-dom";
export default class ReportTable extends Component {
  constructor(props) {
    super(props);
    const typeData =
      this.props.type.charAt(0).toUpperCase() + this.props.type.slice(1);
    this.state = {
      tableData: props.data,
      title: typeData,
    };
    this.columns = [
      {
        key: "name",
        text: "Products",
        sortable: true,
        width: 300,
        cell: (record) => {
          return (
            <Links to={`../../Inventory/Products/View/${record.id}`}>
              {record.name}
            </Links>
          );
        },
      },
      {
        key: "total",
        text: typeData,
        sortable: true,
      },
      {
        key: "return",
        text: "Return",
        sortable: true,
      },
      {
        key: "damage",
        text: "Damage",
        sortable: true,
      },
      {
        key: "avgtotal",
        text: `Avg.${typeData}`,
        sortable: true,
      },
      {
        key: "avgReturn",
        text: "Avg.Return",
        sortable: true,
      },
      {
        key: "avgDamage",
        text: "Avg.Damage",
        sortable: true,
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 10,
      length_menu: [10, 20, 50],
      show_filter: true,
      show_pagination: true,
      button: {
        excel: true,
        print: true,
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  render() {
    return (
      <div className="card">
        <h4 className="card-title">
          <strong>Details Table </strong> <small> {this.state.title}</small>
        </h4>
        <div className="card-body">
          <div className="dataTables_wrapper">
            <ReactDatatable
              className="table table-separated"
              config={this.config}
              records={this.state.tableData}
              columns={this.columns}
            />
          </div>
        </div>
      </div>
    );
  }
}
